import { useEffect, useState } from "react";
import { Clock, Plus, Wallet, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtInr } from "@/lib/api";

const WARN_AT = 60;

export const LowBalancePopup = ({ call, me, cfg, onRecharge, onExtended }) => {
  const [dismissedFor, setDismissedFor] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setDismissedFor(null); }, [call?.callId]);
  if (!call || call.status !== "active" || !cfg || !me) return null;
  if (call.remaining == null || call.remaining > WARN_AT || dismissedFor === call.callId) return null;
  const packs = cfg.packages[call.type] || [];
  const quick = packs.slice(0, 3);
  const coins = me.coins ?? 0;
  const extend = async (minutes) => {
    setBusy(true);
    try { await api.post("/customer/packages/extend", { minutes }); toast.success(`+${minutes} മിനിറ്റ് ചേർത്തു — കോൾ തുടരുന്നു`); onExtended?.(); setDismissedFor(call.callId); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="low-balance-popup" className="absolute inset-x-3 bottom-28 z-30 rounded-3xl glass border border-amber-300/60 p-4 text-white fade-up">
      <div className="flex items-start justify-between gap-2">
        <div><p className="text-sm font-extrabold inline-flex items-center gap-1.5 text-amber-200"><Clock size={14} /> സമയം തീരാറായി — <span className="font-num">{call.remaining}s</span></p><p className="text-[11px] text-white/70 mt-0.5">ബാലൻസ്: <span className="font-num font-bold text-white">{fmtInr(coins)}</span> · കോൾ കട്ട് ചെയ്യാതെ സമയം കൂട്ടാം</p></div>
        <button type="button" data-testid="low-balance-dismiss" onClick={() => setDismissedFor(call.callId)} className="w-7 h-7 rounded-full bg-white/10 inline-flex items-center justify-center"><X size={12} /></button>
      </div>
      <div className="grid grid-cols-3 gap-2 mt-3">
        {quick.map((p) => {
          const can = coins >= p.coins;
          return <button key={p.minutes} type="button" data-testid={`extend-${p.minutes}`} disabled={!can || busy} onClick={() => extend(p.minutes)} className={`rounded-xl h-12 text-xs font-bold inline-flex flex-col items-center justify-center ${can ? "bg-emerald-500 text-white" : "bg-white/10 text-white/40"} disabled:opacity-60`}><span className="inline-flex items-center gap-1"><Plus size={11} /> {p.minutes} മി</span><span className="font-num text-[10px]">₹{p.coins / 6}</span></button>;
        })}
      </div>
      {coins < (quick[0]?.coins || 0) && <button type="button" data-testid="low-balance-recharge" onClick={onRecharge} className="recharge-btn w-full h-11 rounded-full text-xs font-bold inline-flex items-center justify-center gap-2 mt-2"><Wallet size={14} /> ഇപ്പോൾ റീചാർജ് ചെയ്യുക (കോൾ തുടരും)</button>}
    </div>
  );
};
